var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "guide-link-wrap" }, [
      _vm.config.customEntryLink1Url
        ? _c("div", [
            _c(
              "a",
              {
                style: { color: `#${_vm.config.schemeColor}` },
                attrs: {
                  href: _vm.config.customEntryLink1Url,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.config.customEntryLink1Name))]
            ),
          ])
        : _vm._e(),
      _vm.config.customEntryLink2Url
        ? _c("div", [
            _c(
              "a",
              {
                style: { color: `#${_vm.config.schemeColor}` },
                attrs: {
                  href: _vm.config.customEntryLink2Url,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.config.customEntryLink2Name))]
            ),
          ])
        : _vm._e(),
      _vm.config.customEntryLink3Url
        ? _c("div", [
            _c(
              "a",
              {
                style: { color: `#${_vm.config.schemeColor}` },
                attrs: {
                  href: _vm.config.customEntryLink3Url,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.config.customEntryLink3Name))]
            ),
          ])
        : _vm._e(),
      _vm.config.customEntryLink4Url
        ? _c("div", [
            _c(
              "a",
              {
                style: { color: `#${_vm.config.schemeColor}` },
                attrs: {
                  href: _vm.config.customEntryLink4Url,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.config.customEntryLink4Name))]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }